import { render } from "./input.vue?vue&type=template&id=ab2d8d00"
import script from "./input.vue?vue&type=script&lang=ts&setup=true"
export * from "./input.vue?vue&type=script&lang=ts&setup=true"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "ab2d8d00"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ab2d8d00', script)) {
    api.reload('ab2d8d00', script)
  }
  
  module.hot.accept("./input.vue?vue&type=template&id=ab2d8d00", () => {
    api.rerender('ab2d8d00', render)
  })

}

script.__file = "resources/ts/components/form/input.vue"

export default script